import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';

var KeyIcon = function (_a) {
    var className = _a.className;
    return (jsx("svg", __assign({ width: "150", height: "150", viewBox: "0 0 150 150", xmlSpace: "preserve", className: className }, { children: jsx("g", __assign({ transform: "matrix(1 0 0 1 75 75)" }, { children: jsx("path", { style: {
                    stroke: "rgb(0,0,0)",
                    strokeWidth: 0,
                    strokeDasharray: "none",
                    strokeLinecap: "butt",
                    strokeDashoffset: 0,
                    strokeLinejoin: "miter",
                    strokeMiterlimit: 4,
                    fill: "rgb(57,66,66)",
                    fillRule: "nonzero",
                    opacity: 1
                }, transform: "translate(0, 0)", d: "M 71.845 -8.78877 L 71.845 9.526250000000001 L 58.03548 9.526250000000001 L 58.03548 24.78877 L 40.330960000000005 24.78877 L 40.330960000000005 9.52625 L 4.682860000000005 9.52625 C 0.43166000000000526 26.372439999999997 -14.831579999999995 38.85292 -32.99207 38.85292 C -54.43888 38.85292 -71.84499 21.446809999999996 -71.84499 0 C -71.84499 -21.44681 -54.43888 -38.85292 -32.99207 -38.85292 C -14.638879999999997 -38.85292 0.7552400000000006 -26.10617 4.814460000000004 -8.988529999999997 z M -52.30897 0 C -52.30897 10.66293 -43.655 19.3169 -32.99207 19.3169 C -22.32914 19.3169 -13.675169999999998 10.662930000000001 -13.675169999999998 0 C -13.675169999999998 -10.66293 -22.329139999999995 -19.3169 -32.99207 -19.3169 C -43.655 -19.3169 -52.30897 -10.662930000000001 -52.30897 0 z", strokeLinecap: "round" }, void 0) }), void 0) }), void 0));
};

export { KeyIcon as default };
